<template>
    <div class="main_div">
        <div style="height: auto">
            <Loading v-show="isLoading" />
            <n-space>
                <NCard style="margin-top: 20px; margin-left: 80px; border: 0px; min-width: 800px">
                    <n-space item-style="display: flex;" align="center">
                        <div style="font-size: 20px; width: 250px; font-weight: bold">FAQ 관리 > FAQ 등록</div>
                    </n-space>
                    <div class="content_delimiter_line"></div>
                </NCard>
            </n-space>
            <n-space style="width: 1400px; min-width: 1400px; height: auto">
                <NCard style="margin-top: 20px; margin-left: 100px; width: 1400px; min-width: 1400px; height: 100%">
                    <n-space item-style="display: flex;">
                        <div style="font-size: 20px; width: 150px; font-weight: bold">순서</div>
                        <NInput
                            type="number"
                            placeholder="순서"
                            v-model:value="contentOrderNumber"
                            style="width: 100px; height: 30px; text-align: left"
                        />
                    </n-space>
                    <div class="add_content_delimiter_line"></div>
                    <n-space item-style="display: flex;">
                        <div style="font-size: 20px; width: 150px; font-weight: bold">질문</div>
                        <NInput
                            type="text"
                            placeholder=""
                            v-model:value="contentQuestion"
                            style="width: 1000px; height: 30px; text-align: left"
                        />
                    </n-space>
                    <div class="add_content_delimiter_line"></div>

                    <n-space>
                        <div style="font-size: 20px; width: 150px; font-weight: bold">답변</div>

                        <quillEditor
                            v-if="editorReady"
                            v-model:value="contentAnswer"
                            :options="editorOption"
                            theme="snow"
                            @blur="onBlur"
                            @focus="onFocus"
                            @change="onChange"
                            @ready="onReady"
                            style="width: auto; height: 450px"
                        />
                    </n-space>
                    <div class="add_content_delimiter_line"></div>
                    <n-space style="margin-top: 50px" justify="center">
                        <NButton
                            dashed
                            style="width: 250px; height: 30px; border: none"
                            type="warning"
                            v-on:click="hide"
                        >
                            취소
                        </NButton>

                        <NButton
                            dashed
                            style="width: 250px; height: 30px; border: none"
                            type="success"
                            v-on:click="checkAddQna"
                        >
                            {{ submitButtonText }}
                        </NButton>
                    </n-space>
                </NCard>
            </n-space>
        </div>
        <NModal
            v-model:show="isAlert"
            :mask-closable="false"
            :content="alertMessage"
            :type="alertType"
            preset="dialog"
            title="Dialog"
            positive-text="확인"
            @positive-click="onPositiveClick"
        >
        </NModal>
    </div>
</template>

<script setup lang="ts">
import { ref, watch, onMounted } from "vue";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue3-quill";
import { getCallable } from "@/config/env";
import {
    NRadio,
    NCheckbox,
    NSpace,
    NCard,
    NSelect,
    NButton,
    NInput,
    NModal,
    NRadioGroup,
    NUpload,
    useMessage,
    useNotification,
    useDialog,
} from "naive-ui";
import Loading from "@/components/Loading.vue";
import * as common from "@/assets/common/common";
import * as constant from "@/constants/constant";

import { Board } from "@/model/board";

const addQnaCallable = getCallable("addBoard");

const props = defineProps<{
    isAddQna: boolean;
    selectedItem?: Board;
}>();
const emit = defineEmits(["hide"]);
const message = useMessage();
const notification = useNotification();
const dialog = useDialog();
const isLoading = ref<boolean>(false);
const error = ref<string | null>(null);
const submitButtonText = ref<string | null>(null);
const contentOrderNumber = ref<number>(1);
const contentQuestion = ref<string | null>(null);
const contentAnswer = ref<string>("");
const isAlert = ref<boolean>(false);
const alertMessage = ref<string | null>(null);
const alertType = ref<string | null>(null);
const editorReady = ref(false); // 에디터 준비 상태를 위한 ref
const editorOption = ref({
    modules: {
        toolbar: [
            ["bold", "italic", "underline", "strike"], // 굵게, 기울임, 밑줄, 취소선
            ["blockquote", "code-block"], // 인용구, 코드 블록
            [{ header: 1 }, { header: 2 }], // 제목 크기
            [{ list: "ordered" }, { list: "bullet" }], // 순서 있는 목록, 순서 없는 목록
            [{ script: "sub" }, { script: "super" }], // 아래 첨자, 위 첨자
            [{ indent: "-1" }, { indent: "+1" }], // 들여쓰기
            [{ direction: "rtl" }], // 글쓰기 방향
            [{ size: ["small", false, "large", "huge"] }], // 글자 크기
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }, { background: [] }], // 글자색, 배경색
            [{ font: [] }],
            [{ align: [] }],
            ["clean"], // 서식 지우기
        ],
    },
    placeholder: "여기에 내용을 입력하세요...", // placeholder도 options 객체로 설정 가능
    theme: "snow", // 테마도 여기서 설정 가능
});
onMounted(() => {
    editorReady.value = true; // 컴포넌트가 마운트된 후 editorReady를 true로 설정
});
watch(
    () => props.isAddQna,
    (newIsAddQna: boolean) => {
        submitButtonText.value = "등록";
        clearEditor();
    }
);
function onBlur(quill: any) {
    // console.log("editor blur!", quill);
}
function onFocus(quill: any) {
    // console.log("editor focus!", quill);
}
function onChange(quill: any) {
    // console.log("editor change!", quill);
}
function onReady(quill: any) {
    // console.log("editor ready!", quill);
}
function clearEditor() {
    contentQuestion.value = "";
    contentAnswer.value = "";
}

function onPositiveClick() {
    isAlert.value = false;
}

function checkAddQna() {
    alertType.value = "error";
    isAlert.value = true;
    if (!contentQuestion.value) {
        alertMessage.value = "질문을 입력해주세요.";
        return;
    } else if (!contentAnswer.value) {
        alertMessage.value = "질문을 입력해주세요.";
    } else if (!contentOrderNumber.value) {
        alertMessage.value = "질문을 입력해주세요.";
    } else {
        alertType.value = "";
        isAlert.value = false;
        addQnaItem();
    }
}

async function addQnaItem() {
    isLoading.value = true;

    try {
        const result = await addQnaCallable({
            boardType: constant.boardType.QNA,
            boardData: {
                order_num: contentOrderNumber.value,
                question: contentQuestion.value,
                answer: contentAnswer.value,
                author: "(주)COKO Lab.",
            },
        });
        if (common.evalFunctionResult(result)) {
            message.success("FAQ 등록 성공!");
            hide();
        } else {
            notification.error({
                title: "에러",
                description: `FAQ 등록 실패: ${common.getResultError(result) || "오류가 발생했습니다."}`,
                duration: 1500,
                closable: true,
            });
        }
    } catch (error) {
        notification.error({
            title: "에러",
            description: `FAQ 등록 실패: ${error || "오류가 발생했습니다."}`,
            duration: 1500,
            closable: true,
        });
    } finally {
        isLoading.value = false;
    }
}
function hide() {
    emit("hide");
}
</script>

<style scope>
.outer {
    position: relative;
}
.inner {
    position: absolute;
}
.add_content_delimiter_line {
    border: lightgrey 2px solid;
    width: 100%;
    margin-top: 15px;
    margin-bottom: 15px;
}
</style>
